import produce from "immer"
import { CcRequirementPriority } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initCcRequirementPriority: CcRequirementPriority = {
    id: null,
    accountId: null,
    projectId: null,
    name: "",
    description: "",
    creator: null,
    default: false,
    order: 0,
}

const initCcRequirementPriorityState: types.CcRequirementPriorityState = {
    priorityList: {},
    priorityIds: [],
    priorityEdit: initCcRequirementPriority,

    reloadList: true,
    reloadEdit: true,
}

const ccRequirementPriorityReducer = produce((
    draft: types.CcRequirementPriorityState = initCcRequirementPriorityState,
    action: ActionTypes = null,
): types.CcRequirementPriorityState => {
    switch (action.type) {
        case types.CC_REQUIREMENT_PRIORITY_LIST:
            draft.priorityList = action.priorityList
            return draft

        case types.CC_REQUIREMENT_PRIORITY_IDS:
            draft.priorityIds = action.priorityIds
            return draft

        case types.CC_REQUIREMENT_PRIORITY_EDIT:
            draft.priorityEdit = action.priority
            return draft

        case types.CC_REQUIREMENT_PRIORITY_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.CC_REQUIREMENT_PRIORITY_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default ccRequirementPriorityReducer
